import { NotificationListing } from '@components/features/organisms/Notification';

export const NotificationListingPage: React.FC = () => {
  return <NotificationListing />;
};
